import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.slides.ai.harms');
import { AfterViewInit, HostListener, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Service } from "src/libs/portal/season/service";

type Slide = {
    eyebrow: string;
    title: string;
    message: string;
    theme: string;
    kind: string;
    time: string;
    claim?: string;
    bullets?: string[];
    citations?: number[];
    tags?: string[];
    figure?: string;
    evidence?: string[];
    notes: string;
};

type Reference = {
    id: number;
    text: string;
    kind: string;
    label: string;
    short: string;
    url: string;
};

type EvidenceCapture = {
    key: string;
    ref: number;
    label: string;
    title: string;
    url: string;
    filename: string;
    src: string;
};

const FALLBACK_CAPTURES: { [key: string]: EvidenceCapture } = {
    aiIndex2026: {
        key: 'aiIndex2026',
        ref: 1,
        label: 'Stanford HAI AI Index 2026',
        title: 'AI Index Report 2026',
        url: 'https://hai.stanford.edu/assets/files/ai_index_report_2026.pdf',
        filename: 'capture-ai-index-2026.jpg',
        src: '/assets/ai-harms/screenshots/capture-ai-index-2026.jpg'
    },
    unescoGuidance: {
        key: 'unescoGuidance',
        ref: 2,
        label: 'UNESCO Guidance',
        title: 'Guidance for generative AI in education and research',
        url: 'https://unesco.org.uk/site/assets/files/10375/guidance_for_generative_ai_in_education_and_research.pdf',
        filename: 'capture-unesco-guidance.jpg',
        src: '/assets/ai-harms/screenshots/capture-unesco-guidance.jpg'
    },
    nistGenAI: {
        key: 'nistGenAI',
        ref: 3,
        label: 'NIST AI 600-1',
        title: 'Generative AI Profile',
        url: 'https://nvlpubs.nist.gov/nistpubs/ai/NIST.AI.600-1.pdf',
        filename: 'capture-nist-genai-profile.jpg',
        src: '/assets/ai-harms/screenshots/capture-nist-genai-profile.jpg'
    },
    natureModelCollapse: {
        key: 'natureModelCollapse',
        ref: 9,
        label: 'Nature',
        title: 'AI models collapse when trained on recursively generated data',
        url: 'https://www.nature.com/articles/s41586-024-07566-y.pdf',
        filename: 'capture-nature-model-collapse.jpg',
        src: '/assets/ai-harms/screenshots/capture-nature-model-collapse.jpg'
    },
    hallucinationSurvey: {
        key: 'hallucinationSurvey',
        ref: 10,
        label: 'arXiv survey',
        title: 'Hallucination mitigation techniques in LLMs',
        url: 'https://arxiv.org/pdf/2401.01313',
        filename: 'capture-hallucination-survey.jpg',
        src: '/assets/ai-harms/screenshots/capture-hallucination-survey.jpg'
    },
    owaspLLMTop10: {
        key: 'owaspLLMTop10',
        ref: 11,
        label: 'OWASP 2025',
        title: 'Top 10 for LLM Applications',
        url: 'https://owasp.org/www-project-top-10-for-large-language-model-applications/assets/PDF/OWASP-Top-10-for-LLMs-v2025.pdf',
        filename: 'capture-owasp-llm-top10.jpg',
        src: '/assets/ai-harms/screenshots/capture-owasp-llm-top10.jpg'
    },
    jailbreakSurvey: {
        key: 'jailbreakSurvey',
        ref: 13,
        label: 'arXiv survey',
        title: 'Jailbreak attacks and defenses against LLMs',
        url: 'https://arxiv.org/pdf/2407.04295',
        filename: 'capture-jailbreak-survey.jpg',
        src: '/assets/ai-harms/screenshots/capture-jailbreak-survey.jpg'
    },
    workslopReport: {
        key: 'workslopReport',
        ref: 6,
        label: 'BetterUp Labs / Stanford',
        title: 'Workslop: The Hidden Cost of AI-Generated Busywork | BetterUp Labs',
        url: 'https://www.betterup.com/workslop',
        filename: 'capture-workslop-report.jpg',
        src: '/assets/ai-harms/screenshots/capture-workslop-report.jpg'
    },
    oecdFactsNotFakes: {
        key: 'oecdFactsNotFakes',
        ref: 7,
        label: 'OECD report',
        title: 'Facts not fakes: Tackling disinformation, strengthening information integrity',
        url: 'https://www.oecd.org/en/publications/facts-not-fakes_d909ff7a-en.html',
        filename: 'capture-oecd-facts-not-fakes.jpg',
        src: '/assets/ai-harms/screenshots/capture-oecd-facts-not-fakes.jpg'
    },
    deepfakeEval: {
        key: 'deepfakeEval',
        ref: 8,
        label: 'arXiv benchmark',
        title: 'Deepfake-Eval-2024: A multi-modal in-the-wild benchmark of deepfakes circulated in 2024',
        url: 'https://arxiv.org/pdf/2503.02857',
        filename: 'capture-deepfake-eval-2024.jpg',
        src: '/assets/ai-harms/screenshots/capture-deepfake-eval-2024.jpg'
    },
    openaiKeySafety: {
        key: 'openaiKeySafety',
        ref: 14,
        label: 'OpenAI Help',
        title: 'Best Practices for API Key Safety | OpenAI Help Center',
        url: 'https://help.openai.com/en/articles/5112595-best-practices-for-api-key-safety',
        filename: 'capture-openai-api-key-safety.jpg',
        src: '/assets/ai-harms/screenshots/capture-openai-api-key-safety.jpg'
    },
    fccDeepfakeRobocall: {
        key: 'fccDeepfakeRobocall',
        ref: 18,
        label: 'FCC official',
        title: 'FCC proposes $6 million fine for illegal robocalls that used Biden deepfake voice message',
        url: 'https://docs.fcc.gov/public/attachments/DOC-402762A1.pdf',
        filename: 'capture-fcc-deepfake-robocall.jpg',
        src: '/assets/ai-harms/screenshots/capture-fcc-deepfake-robocall.jpg'
    },
    hongKongDeepfakeGuardian: {
        key: 'hongKongDeepfakeGuardian',
        ref: 19,
        label: 'The Guardian',
        title: 'Company worker in Hong Kong pays out £20m in deepfake video call scam',
        url: 'https://www.theguardian.com/world/2024/feb/05/hong-kong-company-deepfake-video-conference-call-scam',
        filename: 'capture-hong-kong-deepfake-scam.jpg',
        src: '/assets/ai-harms/screenshots/capture-hong-kong-deepfake-scam.jpg'
    },
    unescoDeepfakeCase: {
        key: 'unescoDeepfakeCase',
        ref: 20,
        label: 'UNESCO case study',
        title: 'Case study: Can we believe what we hear?',
        url: 'https://www.unesco.org/mil4teachers/en/toolkit-media/indicator-5/activities/ai-disinformation/case-study-2',
        filename: 'capture-unesco-deepfake-case.jpg',
        src: '/assets/ai-harms/screenshots/capture-unesco-deepfake-case.jpg'
    },
    canliiAirCanada: {
        key: 'canliiAirCanada',
        ref: 21,
        label: 'CanLII case note',
        title: 'March 2024 - The CanLII Blog',
        url: 'https://blog.canlii.org/2024/03/',
        filename: 'capture-canlii-air-canada-chatbot.jpg',
        src: '/assets/ai-harms/screenshots/capture-canlii-air-canada-chatbot.jpg'
    },
    mataAvianca: {
        key: 'mataAvianca',
        ref: 22,
        label: 'Court case',
        title: 'Mata v. Avianca, Inc.',
        url: 'https://case-law.vlex.com/vid/mata-v-avianca-inc-1056619281',
        filename: 'capture-mata-v-avianca.jpg',
        src: '/assets/ai-harms/screenshots/capture-mata-v-avianca.jpg'
    },
    apMyCity: {
        key: 'apMyCity',
        ref: 23,
        label: 'AP News',
        title: "NYC's AI chatbot was caught telling businesses to break the law. The city isn't taking it down",
        url: 'https://apnews.com/article/new-york-city-chatbot-misinformation-6ebc71db5b770b9969c906a7ee4fae21',
        filename: 'capture-ap-nyc-mycity-chatbot.jpg',
        src: '/assets/ai-harms/screenshots/capture-ap-nyc-mycity-chatbot.jpg'
    },
};

@Component({
    selector: 'wiz-page-slides-ai-harms',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.slides.ai.harms/view.scss */
@charset "UTF-8";
:host {
  display: block;
  min-height: 100vh;
  background: #f8fafc;
  color: #111827;
}

.deck-shell {
  --accent: #4f46e5;
  --accent-soft: #eef2ff;
  min-height: 100vh;
  background: #f8fafc;
  color: #111827;
}

.deck-progress {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 80;
  height: 4px;
  background: var(--accent);
  transition: width 240ms ease;
}

.deck-topbar {
  position: fixed;
  inset: 4px 0 auto 0;
  z-index: 70;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border-bottom: 1px solid rgba(212, 212, 216, 0.9);
  background: rgba(255, 255, 255, 0.94);
  padding: 12px 18px;
  backdrop-filter: blur(12px);
}

.deck-brand,
.deck-status,
.deck-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.brand-mark {
  display: flex;
  height: 36px;
  width: 36px;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 8px;
  background: #111827;
  color: #fff;
  font-size: 13px;
  font-weight: 800;
  cursor: pointer;
}

.deck-label {
  color: #71717a;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.deck-title-small {
  margin-top: 2px;
  color: #111827;
  font-size: 14px;
  font-weight: 800;
}

.deck-status {
  color: #3f3f46;
  font-size: 13px;
  font-weight: 700;
}

.deck-status span {
  border: 1px solid #e4e4e7;
  border-radius: 999px;
  background: #fafafa;
  padding: 5px 9px;
}

.deck-actions button,
.deck-controls button,
.source-drawer button,
.speaker-notes button {
  border: 1px solid #d4d4d8;
  border-radius: 7px;
  background: #fff;
  color: #3f3f46;
  cursor: pointer;
  font-size: 12px;
  font-weight: 700;
}

.deck-actions button {
  height: 32px;
  padding: 0 9px;
}

.deck-actions button:disabled {
  cursor: wait;
  opacity: 0.58;
}

.deck-actions button.active,
.deck-controls button:hover,
.deck-actions button:hover {
  border-color: #111827;
  background: #111827;
  color: #fff;
}

.deck-viewport {
  height: 100vh;
  overflow-y: auto;
  scroll-snap-type: y mandatory;
  scroll-behavior: smooth;
}

.deck-slide {
  min-height: 100vh;
  scroll-snap-align: start;
  padding: 92px 36px 72px;
  --accent: #4f46e5;
  --accent-soft: #eef2ff;
}

.deck-slide.theme-ink {
  --accent: #111827;
  --accent-soft: #f4f4f5;
}

.deck-slide.theme-indigo {
  --accent: #4f46e5;
  --accent-soft: #eef2ff;
}

.deck-slide.theme-emerald {
  --accent: #059669;
  --accent-soft: #ecfdf5;
}

.deck-slide.theme-rose {
  --accent: #e11d48;
  --accent-soft: #fff1f2;
}

.deck-slide.theme-amber {
  --accent: #d97706;
  --accent-soft: #fffbeb;
}

.deck-slide.theme-sky {
  --accent: #0284c7;
  --accent-soft: #f0f9ff;
}

.deck-slide.theme-violet {
  --accent: #7c3aed;
  --accent-soft: #f5f3ff;
}

.deck-slide.theme-zinc,
.deck-slide.theme-slate {
  --accent: #334155;
  --accent-soft: #f1f5f9;
}

.slide-inner {
  display: grid;
  min-height: calc(100vh - 164px);
  grid-template-columns: minmax(0, 0.92fr) minmax(460px, 1.08fr);
  gap: 32px;
  align-items: center;
  max-width: 1320px;
  margin: 0 auto;
}

.slide-copy {
  max-width: 620px;
}

.slide-eyebrow {
  display: inline-flex;
  border: 1px solid color-mix(in srgb, var(--accent) 24%, #fff);
  border-radius: 999px;
  background: var(--accent-soft);
  color: var(--accent);
  padding: 6px 10px;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.slide-copy h1 {
  margin: 22px 0 0;
  color: #111827;
  font-size: 52px;
  font-weight: 850;
  line-height: 1.13;
}

.slide-message {
  margin: 18px 0 0;
  color: #3f3f46;
  font-size: 21px;
  font-weight: 650;
  line-height: 1.55;
  word-break: keep-all;
}

.slide-bullets {
  margin: 24px 0 0;
  padding: 0;
  list-style: none;
}

.slide-bullets li {
  position: relative;
  margin-top: 12px;
  padding-left: 22px;
  color: #52525b;
  font-size: 16px;
  font-weight: 550;
  line-height: 1.6;
  word-break: keep-all;
}

.slide-bullets li::before {
  position: absolute;
  left: 0;
  top: 11px;
  height: 7px;
  width: 7px;
  border-radius: 999px;
  background: var(--accent);
  content: "";
}

.argument-line {
  margin-top: 22px;
  border-left: 4px solid var(--accent);
  border-radius: 8px;
  background: color-mix(in srgb, var(--accent-soft) 72%, #fff);
  color: #20313f;
  padding: 14px 16px;
  font-size: 16px;
  font-weight: 900;
  line-height: 1.5;
  word-break: keep-all;
}

.citation-row {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  margin-top: 24px;
}

.citation-row button {
  border: 1px solid color-mix(in srgb, var(--accent) 28%, #d4d4d8);
  border-radius: 999px;
  background: #fff;
  color: var(--accent);
  cursor: pointer;
  font-size: 12px;
  font-weight: 800;
  padding: 5px 8px;
}

.paper-strip {
  display: grid;
  gap: 8px;
  margin-top: 14px;
  border-left: 3px solid var(--accent);
  padding-left: 12px;
}

.paper-strip-label {
  color: #71717a;
  font-size: 11px;
  font-weight: 900;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.paper-strip button {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  background: #fff;
  color: #27272a;
  cursor: pointer;
  padding: 9px 10px;
  text-align: left;
}

.paper-strip button:hover {
  border-color: var(--accent);
  background: var(--accent-soft);
}

.paper-strip strong {
  min-width: 0;
  overflow: hidden;
  font-size: 12px;
  font-weight: 850;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.source-kind,
.source-item-head em,
.selected-source-head em {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: var(--accent-soft);
  color: var(--accent);
  padding: 3px 7px;
  font-size: 10px;
  font-style: normal;
  font-weight: 900;
  white-space: nowrap;
}

.capture-strip {
  margin-top: 14px;
}

.capture-strip-label {
  color: #71717a;
  font-size: 11px;
  font-weight: 900;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.capture-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 9px;
  margin-top: 8px;
}

.capture-card {
  display: grid;
  min-width: 0;
  border: 1px solid #d4d4d8;
  border-radius: 8px;
  background: #fff;
  color: #27272a;
  cursor: pointer;
  overflow: hidden;
  padding: 0;
  text-align: left;
}

.capture-card:hover {
  border-color: var(--accent);
  box-shadow: 0 12px 26px rgba(15, 23, 42, 0.1);
}

.capture-card img {
  display: block;
  width: 100%;
  height: 118px;
  background: #f8fafc;
  object-fit: cover;
  object-position: top;
}

.capture-card .capture-meta {
  margin: 9px 10px 0;
  color: var(--accent);
  font-size: 10px;
  font-weight: 900;
  letter-spacing: 0.04em;
}

.capture-card strong {
  display: -webkit-box;
  overflow: hidden;
  min-height: 34px;
  margin: 4px 10px 10px;
  color: #18181b;
  font-size: 12px;
  font-weight: 850;
  line-height: 1.35;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.slide-visual {
  display: grid;
  gap: 14px;
  align-content: center;
  min-width: 0;
}

.visual-evidence {
  overflow: hidden;
  border: 1px solid color-mix(in srgb, var(--accent) 30%, #d4d4d8);
  border-radius: 8px;
  background: #fff;
  padding: 14px;
  box-shadow: 0 18px 48px rgba(15, 23, 42, 0.1);
}

.visual-evidence-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
}

.visual-evidence-head span {
  color: var(--accent);
  font-size: 12px;
  font-weight: 950;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.visual-evidence-head button {
  border: 1px solid color-mix(in srgb, var(--accent) 28%, #d4d4d8);
  border-radius: 999px;
  background: var(--accent-soft);
  color: var(--accent);
  cursor: pointer;
  padding: 7px 11px;
  font-size: 11px;
  font-weight: 900;
}

.visual-evidence-main {
  display: block;
  overflow: hidden;
  width: 100%;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  background: #f8fafc;
  cursor: pointer;
  padding: 0;
}

.visual-evidence-main img {
  display: block;
  width: 100%;
  height: clamp(230px, 31vh, 360px);
  object-fit: cover;
  object-position: top center;
}

.visual-evidence-caption {
  display: grid;
  gap: 3px;
  margin-top: 10px;
}

.visual-evidence-caption strong {
  overflow: hidden;
  color: #18181b;
  font-size: 14px;
  font-weight: 950;
  line-height: 1.3;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.visual-evidence-caption small {
  display: -webkit-box;
  overflow: hidden;
  color: #52525b;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.35;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.visual-evidence-related {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  margin-top: 10px;
}

.visual-evidence-related button {
  display: grid;
  grid-template-columns: 54px minmax(0, 1fr);
  gap: 8px;
  align-items: center;
  min-width: 0;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  background: #fafafa;
  color: #27272a;
  cursor: pointer;
  padding: 7px;
  text-align: left;
}

.visual-evidence-related img {
  width: 54px;
  height: 38px;
  border-radius: 5px;
  object-fit: cover;
  object-position: top center;
}

.visual-evidence-related span {
  overflow: hidden;
  color: #3f3f46;
  font-size: 11px;
  font-weight: 850;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.hero-visual,
.question-visual,
.counter-visual,
.compare-visual,
.workslop-visual,
.fake-visual,
.quiz-visual,
.terminal-visual,
.case-visual,
.map-visual,
.checklist-visual,
.defense-visual,
.rebuttal-visual,
.conclusion-visual,
.qa-visual,
.citation-page-visual,
.default-visual {
  border: 1px solid #d4d4d8;
  border-radius: 8px;
  background: #fff;
  padding: 26px;
  box-shadow: 0 18px 48px rgba(15, 23, 42, 0.08);
}

.typing-line {
  overflow: hidden;
  width: 28ch;
  border-right: 3px solid var(--accent);
  color: #111827;
  font-size: 31px;
  font-weight: 850;
  line-height: 1.25;
  white-space: nowrap;
  animation: typing 3.1s steps(28, end), caret 0.8s step-end infinite;
}

@keyframes typing {
  from {
    width: 0;
  }
  to {
    width: 28ch;
  }
}
@keyframes caret {
  50% {
    border-color: transparent;
  }
}
.signal-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  margin-top: 28px;
}

.signal-grid span {
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  background: var(--accent-soft);
  color: var(--accent);
  padding: 16px 12px;
  text-align: center;
  font-size: 14px;
  font-weight: 800;
}

.hero-rule {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  margin-top: 24px;
}

.hero-rule span {
  border-bottom: 3px solid var(--accent);
  color: #18181b;
  padding-bottom: 7px;
  font-size: 18px;
  font-weight: 850;
}

.question-visual {
  display: grid;
  gap: 12px;
}

.question-visual button,
.quiz-visual button,
.toggle-row button,
.qa-visual button,
.citation-page-visual button {
  border: 1px solid #d4d4d8;
  border-radius: 8px;
  background: #fff;
  color: #27272a;
  cursor: pointer;
  padding: 14px 16px;
  text-align: left;
  font-size: 15px;
  font-weight: 800;
}

.question-visual button:hover,
.quiz-visual button:hover,
.quiz-visual button.selected,
.toggle-row button.active,
.qa-visual button:hover,
.citation-page-visual button:hover {
  border-color: var(--accent);
  background: var(--accent-soft);
  color: var(--accent);
}

.question-caption,
.flow-line,
.figure-hint,
.map-note,
.quiz-answer {
  border-radius: 8px;
  background: var(--accent-soft);
  color: var(--accent);
  padding: 12px 14px;
  font-size: 13px;
  font-weight: 800;
}

.figure-frame {
  overflow: hidden;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  background: #fff;
}

:host ::ng-deep .figure-frame svg {
  display: block;
  width: 100%;
  height: auto;
}

.figure-hint {
  margin-top: 10px;
}

.counter-visual {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.counter-card {
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  background: #fafafa;
  padding: 18px;
}

.counter-value {
  color: var(--accent);
  font-size: 44px;
  font-weight: 900;
  line-height: 1;
}

.counter-label {
  margin-top: 8px;
  color: #52525b;
  font-size: 13px;
  font-weight: 800;
}

.flow-line {
  grid-column: 1/-1;
}

.compare-visual {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}

.compare-panel {
  min-height: 220px;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  padding: 22px;
}

.compare-panel.good {
  background: #eef2ff;
}

.compare-panel.risk {
  background: #fff1f2;
}

.compare-panel h3,
.verify-card h3 {
  margin: 0;
  color: #111827;
  font-size: 23px;
  font-weight: 900;
}

.compare-panel p,
.verify-card p {
  margin: 14px 0 0;
  color: #52525b;
  font-size: 16px;
  font-weight: 650;
  line-height: 1.6;
}

.toggle-row {
  display: flex;
  gap: 10px;
}

.work-doc {
  margin-top: 18px;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  background: #fafafa;
  padding: 20px;
}

.doc-line {
  height: 13px;
  margin-bottom: 12px;
  border-radius: 999px;
  background: #d4d4d8;
}

.doc-line.w90 {
  width: 90%;
}

.doc-line.w70 {
  width: 70%;
}

.doc-line.w50 {
  width: 50%;
}

.doc-warning {
  margin-top: 14px;
  border-left: 4px solid #dc2626;
  background: #fef2f2;
  color: #991b1b;
  padding: 12px;
  font-size: 13px;
  font-weight: 850;
}

.work-doc.repaired .doc-warning {
  border-left-color: #059669;
  background: #ecfdf5;
  color: #047857;
}

.meter {
  position: relative;
  overflow: hidden;
  margin-top: 18px;
  border: 1px solid #d1fae5;
  border-radius: 8px;
  background: #ecfdf5;
  padding: 13px 14px;
  color: #047857;
  font-size: 13px;
}

.meter-fill {
  position: absolute;
  inset: 0 auto 0 0;
  width: 62%;
  background: rgba(16, 185, 129, 0.15);
  animation: meterFill 2.6s ease-in-out infinite alternate;
}

.meter strong {
  position: relative;
}

@keyframes meterFill {
  from {
    width: 32%;
  }
  to {
    width: 86%;
  }
}
.fake-visual {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}

.verify-card {
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  background: #fafafa;
  padding: 22px;
}

.verify-card.suspect {
  border-color: #fecdd3;
  background: #fff1f2;
}

.flash-band {
  grid-column: 1/-1;
  border-radius: 8px;
  background: #111827;
  color: #fff;
  padding: 14px 16px;
  font-size: 15px;
  font-weight: 850;
  animation: alertPulse 1.8s ease-in-out infinite alternate;
}

@keyframes alertPulse {
  from {
    opacity: 0.76;
  }
  to {
    opacity: 1;
  }
}
.quiz-visual {
  display: grid;
  gap: 12px;
}

.quiz-prompt {
  color: #111827;
  font-size: 22px;
  font-weight: 900;
}

.terminal-visual {
  background: #111827;
  color: #d1d5db;
}

.terminal-head {
  border-bottom: 1px solid #374151;
  color: #a7f3d0;
  padding-bottom: 10px;
  font-size: 13px;
  font-weight: 850;
}

.terminal-visual pre {
  margin: 18px 0 0;
  white-space: pre-line;
  color: #e5e7eb;
  font-size: 16px;
  line-height: 1.8;
}

.case-visual {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  perspective: 1000px;
}

.flip-card {
  position: relative;
  min-height: 240px;
  transform-style: preserve-3d;
  transition: transform 500ms ease;
}

.flip-card:hover {
  transform: rotateY(180deg);
}

.flip-card .front,
.flip-card .back {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  padding: 18px;
  backface-visibility: hidden;
  text-align: center;
  font-weight: 850;
}

.flip-card .front {
  background: var(--accent-soft);
  color: var(--accent);
  font-size: 20px;
}

.flip-card .back {
  background: #111827;
  color: #fff;
  font-size: 14px;
  line-height: 1.55;
  transform: rotateY(180deg);
}

.map-visual {
  position: relative;
  min-height: 360px;
  background: #fff;
}

.map-node {
  position: absolute;
  max-width: 220px;
  border: 1px solid #fecdd3;
  border-radius: 8px;
  background: #fff1f2;
  color: #be123c;
  padding: 14px;
  font-size: 14px;
  font-weight: 850;
  line-height: 1.5;
}

.map-node.slovakia {
  left: 12%;
  top: 18%;
}

.map-node.usa {
  left: 48%;
  top: 8%;
}

.map-node.hongkong {
  right: 10%;
  top: 42%;
}

.map-note {
  position: absolute;
  left: 10%;
  right: 10%;
  bottom: 20px;
}

.checklist-visual {
  display: grid;
  gap: 12px;
}

.check-item {
  position: relative;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  background: #fafafa;
  padding: 16px 16px 16px 44px;
  color: #27272a;
  font-size: 16px;
  font-weight: 800;
}

.check-item::before {
  position: absolute;
  left: 16px;
  top: 18px;
  height: 14px;
  width: 14px;
  border-radius: 999px;
  background: #10b981;
  content: "";
}

.defense-visual {
  display: grid;
  gap: 12px;
}

.defense-layer {
  border: 1px solid color-mix(in srgb, var(--accent) 22%, #e4e4e7);
  border-radius: 8px;
  background: var(--accent-soft);
  color: var(--accent);
  padding: 18px;
  font-size: 17px;
  font-weight: 900;
}

.rebuttal-visual {
  display: grid;
  gap: 14px;
}

.rebuttal-card {
  display: grid;
  gap: 9px;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  background: #fff;
  padding: 20px;
}

.rebuttal-card span {
  width: fit-content;
  border-bottom: 2px solid var(--accent);
  color: var(--accent);
  padding-bottom: 4px;
  font-size: 11px;
  font-weight: 950;
  letter-spacing: 0.12em;
}

.rebuttal-card strong {
  color: #111827;
  font-size: 24px;
  font-weight: 950;
  line-height: 1.25;
  word-break: keep-all;
}

.rebuttal-card p {
  margin: 0;
  color: #52525b;
  font-size: 15px;
  font-weight: 650;
  line-height: 1.55;
  word-break: keep-all;
}

.rebuttal-card.objection {
  border-color: #fecdd3;
  background: #fff1f2;
}

.rebuttal-card.answer {
  border-color: color-mix(in srgb, var(--accent) 28%, #d4d4d8);
  background: var(--accent-soft);
}

.rebuttal-rule {
  border-radius: 8px;
  background: #111827;
  color: #fff;
  padding: 15px 16px;
  font-size: 15px;
  font-weight: 900;
  line-height: 1.55;
  word-break: keep-all;
}

.conclusion-visual {
  display: grid;
  gap: 12px;
}

.axiom {
  border-bottom: 4px solid var(--accent);
  padding: 24px 0 14px;
  color: #111827;
  font-size: 42px;
  font-weight: 950;
  line-height: 1.1;
}

.shortcut-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.shortcut-grid div {
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  background: #fafafa;
  padding: 16px;
  color: #27272a;
  font-size: 14px;
  font-weight: 850;
}

.qa-visual button {
  width: 100%;
  margin-top: 14px;
  text-align: center;
}

.citation-page-visual {
  display: grid;
  gap: 14px;
}

.citation-page-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-bottom: 1px solid #e4e4e7;
  padding-bottom: 12px;
}

.citation-page-head span {
  color: #71717a;
  font-size: 11px;
  font-weight: 900;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.citation-page-head button {
  padding: 9px 12px;
  font-size: 12px;
}

.citation-groups {
  display: grid;
  gap: 12px;
  max-height: min(64vh, 720px);
  overflow: auto;
  padding-right: 4px;
}

.citation-group {
  display: grid;
  gap: 8px;
}

.citation-group-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px;
}

.citation-group h3 {
  margin: 0;
  color: #18181b;
  font-size: 15px;
  font-weight: 950;
}

.citation-group small {
  color: #71717a;
  font-size: 11px;
  font-weight: 700;
}

.citation-entries {
  display: grid;
  gap: 7px;
}

.citation-entry {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 7px;
  align-items: stretch;
}

.citation-entry button {
  display: grid;
  grid-template-columns: 46px minmax(0, 1fr);
  gap: 8px;
  padding: 9px;
}

.citation-index {
  color: var(--accent);
  font-size: 12px;
  font-weight: 950;
}

.citation-entry strong,
.citation-entry small {
  display: block;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.citation-entry strong {
  color: #27272a;
  font-size: 12px;
  font-weight: 900;
  line-height: 1.25;
  white-space: nowrap;
}

.citation-entry small {
  margin-top: 4px;
  color: #52525b;
  font-size: 10px;
  font-weight: 550;
  line-height: 1.3;
  white-space: nowrap;
}

.citation-entry a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #d4d4d8;
  border-radius: 8px;
  background: #fff;
  color: var(--accent);
  padding: 0 10px;
  text-decoration: none;
  font-size: 11px;
  font-weight: 900;
}

.citation-entry a:hover {
  border-color: var(--accent);
  background: var(--accent-soft);
}

.bibliography-list {
  display: grid;
  gap: 8px;
  max-height: min(64vh, 720px);
  overflow: auto;
  padding-right: 4px;
}

.bibliography-entry {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 8px;
  align-items: stretch;
  border-bottom: 1px solid #e3e8e5;
  padding-bottom: 8px;
}

.bibliography-entry button {
  display: grid;
  grid-template-columns: 44px minmax(0, 1fr);
  gap: 10px;
  border: 0;
  background: transparent;
  color: #27272a;
  cursor: pointer;
  padding: 0;
  text-align: left;
}

.bibliography-index {
  color: var(--accent);
  font-size: 12px;
  font-weight: 950;
  line-height: 1.45;
}

.bibliography-entry p {
  margin: 0;
  color: #2f3c3e;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.45;
}

.bibliography-entry a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  align-self: start;
  border: 1px solid #d4d4d8;
  border-radius: 7px;
  background: #fff;
  color: var(--accent);
  min-height: 28px;
  padding: 0 9px;
  text-decoration: none;
  font-size: 11px;
  font-weight: 900;
}

.bibliography-entry a:hover {
  border-color: var(--accent);
  background: var(--accent-soft);
}

.citation-page-note {
  border-radius: 8px;
  background: var(--accent-soft);
  color: var(--accent);
  padding: 10px 12px;
  font-size: 12px;
  font-weight: 850;
}

.deck-controls {
  position: fixed;
  left: 50%;
  bottom: 16px;
  z-index: 70;
  display: flex;
  align-items: center;
  gap: 10px;
  width: min(620px, 100% - 32px);
  transform: translateX(-50%);
  border: 1px solid rgba(212, 212, 216, 0.9);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.94);
  padding: 10px;
  backdrop-filter: blur(12px);
}

.deck-controls button {
  height: 34px;
  padding: 0 12px;
}

.deck-controls input {
  flex: 1;
  accent-color: var(--accent);
}

.speaker-notes,
.source-drawer {
  position: fixed;
  z-index: 90;
  border: 1px solid #d4d4d8;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 24px 70px rgba(15, 23, 42, 0.18);
}

.speaker-notes,
.source-drawer {
  top: 72px;
  bottom: 72px;
  width: min(420px, 100% - 28px);
  padding: 18px;
  transition: transform 260ms ease;
}

.speaker-notes {
  left: 14px;
  transform: translateX(calc(-100% - 24px));
}

.speaker-notes.open {
  transform: translateX(0);
}

.source-drawer {
  right: 14px;
  transform: translateX(calc(100% + 24px));
}

.source-drawer.open {
  transform: translateX(0);
}

.panel-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-bottom: 1px solid #e4e4e7;
  padding-bottom: 12px;
}

.panel-head h2 {
  margin: 0;
  color: #111827;
  font-size: 17px;
  font-weight: 900;
}

.panel-head button {
  height: 30px;
  padding: 0 10px;
}

.note-meta,
.selected-source {
  margin-top: 14px;
  border-radius: 8px;
  background: var(--accent-soft);
  padding: 12px;
  font-size: 13px;
  font-weight: 850;
}

.note-meta {
  color: var(--accent);
}

.selected-source {
  color: #27272a;
}

.selected-source-head {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--accent);
  font-size: 12px;
  font-weight: 900;
}

.selected-source strong {
  display: block;
  margin-top: 8px;
  color: #18181b;
  line-height: 1.35;
}

.selected-source p {
  margin: 8px 0 0;
  color: #52525b;
  font-size: 12px;
  font-weight: 550;
  line-height: 1.45;
}

.speaker-notes p {
  color: #3f3f46;
  font-size: 15px;
  font-weight: 550;
  line-height: 1.7;
}

.source-tabs {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 6px;
  margin-top: 12px;
}

.source-tabs button {
  min-width: 0;
  height: 32px;
  padding: 0 8px;
  font-size: 11px;
  font-weight: 850;
}

.source-tabs button.active {
  border-color: var(--accent);
  background: var(--accent-soft);
  color: var(--accent);
}

.source-list {
  height: calc(100% - 202px);
  margin-top: 12px;
  overflow: auto;
}

.source-item {
  display: grid;
  grid-template-columns: 46px minmax(0, 1fr);
  gap: 8px;
  width: 100%;
  margin-bottom: 8px;
  padding: 9px;
  text-align: left;
}

.source-item.selected {
  border-color: var(--accent);
  background: var(--accent-soft);
}

.source-number {
  color: var(--accent);
  font-weight: 900;
}

.source-item div {
  min-width: 0;
}

.source-item-head {
  display: flex;
  align-items: center;
  gap: 7px;
  min-width: 0;
}

.source-item-head strong {
  min-width: 0;
  overflow: hidden;
  color: #27272a;
  font-size: 12px;
  font-weight: 850;
  line-height: 1.3;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.source-item small {
  display: block;
  overflow: hidden;
  margin-top: 4px;
  color: #52525b;
  font-size: 11px;
  line-height: 1.35;
  text-overflow: ellipsis;
}

/* Research deck redesign: calmer academic tone with integrated evidence cards. */
.deck-shell {
  --accent: #25636f;
  --accent-soft: #eaf4f5;
  background: #f7f8f5;
  color: #18212f;
}

.deck-progress {
  height: 3px;
  background: #25636f;
}

.deck-topbar {
  inset: 3px 0 auto 0;
  border-bottom: 1px solid #d7dedb;
  background: rgba(250, 251, 248, 0.96);
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.055);
}

.brand-mark {
  background: #20313f;
  font-family: Georgia, "Times New Roman", serif;
  letter-spacing: 0.03em;
}

.deck-label {
  color: #64716f;
  letter-spacing: 0.18em;
}

.deck-title-small {
  color: #20313f;
  font-weight: 900;
}

.deck-status span {
  border-color: #d7dedb;
  background: #f7f8f5;
  color: #43504f;
}

.deck-actions button,
.deck-controls button,
.source-drawer button,
.speaker-notes button {
  border-color: #cfd8d4;
  background: #fbfcfa;
  color: #364646;
}

.deck-actions button {
  font-weight: 800;
}

.deck-actions button.active,
.deck-controls button:hover,
.deck-actions button:hover {
  border-color: #20313f;
  background: #20313f;
  color: #fff;
}

.deck-slide {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.74), rgba(247, 248, 245, 0.9)), #f7f8f5;
  padding: 88px 42px 76px;
}

.deck-slide.theme-ink,
.deck-slide.theme-zinc,
.deck-slide.theme-slate {
  --accent: #20313f;
  --accent-soft: #edf1f0;
}

.deck-slide.theme-indigo,
.deck-slide.theme-violet {
  --accent: #4e5f8f;
  --accent-soft: #eef2fb;
}

.deck-slide.theme-emerald {
  --accent: #2f6f5f;
  --accent-soft: #eaf5ef;
}

.deck-slide.theme-rose {
  --accent: #9d4253;
  --accent-soft: #f8ecef;
}

.deck-slide.theme-amber {
  --accent: #9a6b25;
  --accent-soft: #f7f1e5;
}

.deck-slide.theme-sky {
  --accent: #286f8f;
  --accent-soft: #eaf4f8;
}

.slide-inner {
  grid-template-columns: minmax(0, 0.86fr) minmax(520px, 1.14fr);
  gap: 34px;
  max-width: 1380px;
}

.slide-copy {
  max-width: 650px;
  border-left: 4px solid var(--accent);
  padding-left: 22px;
}

.slide-eyebrow {
  border: 0;
  border-radius: 0;
  background: transparent;
  color: var(--accent);
  padding: 0;
  font-size: 12px;
  letter-spacing: 0.16em;
}

.slide-copy h1 {
  max-width: 12ch;
  margin-top: 18px;
  color: #18212f;
  font-size: 50px;
  font-weight: 900;
  letter-spacing: 0;
  line-height: 1.08;
}

.slide-message {
  margin-top: 20px;
  color: #344143;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.5;
}

.slide-bullets {
  margin-top: 26px;
  display: grid;
  gap: 10px;
}

.slide-bullets li {
  border: 1px solid #dde4e0;
  border-left: 4px solid var(--accent);
  background: rgba(255, 255, 255, 0.72);
  padding: 12px 14px 12px 16px;
  color: #253233;
  font-size: 16px;
  font-weight: 700;
}

.slide-bullets li::before {
  display: none;
}

.citation-row {
  margin-top: 18px;
}

.citation-row button {
  border-color: color-mix(in srgb, var(--accent) 28%, #d7dedb);
  background: #fbfcfa;
  color: var(--accent);
}

.slide-visual {
  gap: 16px;
}

.visual-evidence {
  position: relative;
  overflow: hidden;
  border-color: #d7dedb;
  border-left: 4px solid var(--accent);
  background: rgba(255, 255, 255, 0.94);
  padding: 0;
  box-shadow: 0 14px 34px rgba(15, 23, 42, 0.08);
}

.visual-evidence-head {
  border-bottom: 1px solid #e3e8e5;
  margin-bottom: 0;
  padding: 12px 14px;
}

.visual-evidence-head span {
  color: #20313f;
  font-size: 11px;
  letter-spacing: 0.14em;
}

.visual-evidence-head button {
  border-color: #d7dedb;
  background: #ffffff;
  color: #25636f;
  padding: 6px 10px;
}

.visual-evidence-main {
  border: 0;
  border-radius: 0;
  background: #ffffff;
}

.visual-evidence-main img {
  height: clamp(240px, 34vh, 390px);
  object-fit: contain;
  object-position: center;
}

.visual-evidence-caption {
  border-top: 1px solid #e3e8e5;
  margin-top: 0;
  padding: 12px 14px 14px;
}

.visual-evidence-caption strong {
  color: #20313f;
  font-size: 13px;
}

.visual-evidence-caption small {
  color: #566564;
}

.visual-evidence-caption::before {
  display: block;
  width: fit-content;
  margin-bottom: 7px;
  border: 1px solid color-mix(in srgb, var(--accent) 32%, #d7dedb);
  border-radius: 999px;
  background: var(--accent-soft);
  color: var(--accent);
  content: "원문 기반 캡처";
  padding: 4px 8px;
  font-size: 10px;
  font-weight: 900;
  letter-spacing: 0.04em;
}

.visual-evidence-related {
  margin: 0;
  padding: 0 14px 14px;
}

.visual-evidence-related button {
  border-color: #dce3df;
  background: #ffffff;
}

.hero-visual,
.question-visual,
.counter-visual,
.compare-visual,
.workslop-visual,
.fake-visual,
.quiz-visual,
.terminal-visual,
.case-visual,
.map-visual,
.checklist-visual,
.defense-visual,
.rebuttal-visual,
.conclusion-visual,
.qa-visual,
.citation-page-visual,
.default-visual {
  border-color: #d7dedb;
  background: rgba(251, 252, 250, 0.92);
  box-shadow: 0 12px 34px rgba(15, 23, 42, 0.08);
}

.typing-line {
  width: auto;
  border-right: 0;
  animation: none;
  color: #20313f;
  font-size: 28px;
}

.hero-visual {
  display: grid;
  gap: 18px;
  align-content: start;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.96), rgba(239, 244, 243, 0.96)), #ffffff;
}

.hero-kicker {
  width: fit-content;
  border-bottom: 2px solid var(--accent);
  color: var(--accent);
  padding-bottom: 5px;
  font-size: 12px;
  font-weight: 950;
  letter-spacing: 0.14em;
}

.hero-thesis {
  display: grid;
  gap: 10px;
}

.hero-thesis div {
  display: grid;
  grid-template-columns: 42px minmax(0, 0.8fr) minmax(0, 1.6fr);
  gap: 12px;
  align-items: center;
  border: 1px solid #dce3df;
  border-left: 4px solid var(--accent);
  border-radius: 8px;
  background: #ffffff;
  padding: 12px 14px;
}

.hero-thesis small {
  color: var(--accent);
  font-size: 11px;
  font-weight: 950;
  letter-spacing: 0.08em;
}

.hero-thesis strong {
  color: #20313f;
  font-size: 16px;
  font-weight: 950;
  line-height: 1.25;
}

.hero-thesis span {
  color: #566564;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.45;
  word-break: keep-all;
}

.signal-grid span,
.hero-rule span,
.question-caption,
.flow-line,
.figure-hint,
.map-note,
.quiz-answer,
.defense-layer,
.rebuttal-card.answer,
.citation-page-note {
  background: var(--accent-soft);
  color: var(--accent);
}

.counter-card,
.verify-card,
.compare-panel,
.check-item,
.rebuttal-card,
.shortcut-grid div {
  border-color: #dce3df;
  background: #ffffff;
}

.compare-panel.good,
.compare-panel.risk,
.verify-card.suspect,
.rebuttal-card.objection {
  background: #ffffff;
}

.flash-band {
  background: #20313f;
  animation: none;
}

.meter-fill {
  animation: none;
}

.flip-card,
.flip-card:hover {
  min-height: auto;
  transform: none;
  transform-style: flat;
}

.flip-card .front,
.flip-card .back {
  position: relative;
  inset: auto;
  min-height: 116px;
  transform: none;
  backface-visibility: visible;
}

.flip-card .back {
  margin-top: 8px;
}

.case-visual {
  perspective: none;
}

.flip-card .front {
  display: grid;
  align-content: center;
  gap: 7px;
  justify-items: center;
}

.flip-card .front span {
  color: color-mix(in srgb, var(--accent) 78%, #20313f);
  font-size: 11px;
  font-weight: 950;
  letter-spacing: 0.08em;
}

.flip-card .front strong {
  color: var(--accent);
  font-size: 19px;
  font-weight: 950;
  line-height: 1.2;
}

.map-visual {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.98), rgba(248, 236, 239, 0.78)), #ffffff;
}

.map-node {
  display: grid;
  gap: 5px;
  width: 240px;
  max-width: 240px;
  box-shadow: 0 10px 24px rgba(157, 66, 83, 0.1);
}

.map-node small {
  color: #9d4253;
  font-size: 11px;
  font-weight: 950;
  letter-spacing: 0.07em;
}

.map-node strong {
  color: #20313f;
  font-size: 16px;
  font-weight: 950;
  line-height: 1.25;
}

.map-node span {
  color: #6f3844;
  font-size: 13px;
  font-weight: 750;
  line-height: 1.45;
}

.conclusion-visual {
  gap: 0;
  border-left: 4px solid var(--accent);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.96), rgba(237, 241, 240, 0.96)), #ffffff;
}

.terminal-visual {
  background: #20313f;
}

.conclusion-statement {
  margin-top: 22px;
  border-top: 1px solid #dce3df;
  color: #344143;
  padding-top: 18px;
  font-size: 18px;
  font-weight: 850;
  line-height: 1.55;
  word-break: keep-all;
}

.source-drawer,
.speaker-notes,
.deck-controls {
  border-color: #cfd8d4;
  background: #fbfcfa;
}

@media (max-width: 980px) {
  .deck-topbar {
    align-items: flex-start;
    flex-wrap: wrap;
  }
  .slide-inner {
    grid-template-columns: 1fr;
    gap: 22px;
    align-items: start;
  }
  .slide-copy h1 {
    font-size: 38px;
  }
  .slide-message {
    font-size: 18px;
  }
  .counter-visual,
  .compare-visual,
  .fake-visual,
  .case-visual,
  .citation-entry,
  .bibliography-entry {
    grid-template-columns: 1fr;
  }
  .citation-page-head,
  .citation-group-head {
    align-items: flex-start;
    flex-direction: column;
  }
  .capture-grid {
    grid-template-columns: 1fr;
  }
  .capture-card img {
    height: 150px;
  }
  .visual-evidence-main img {
    height: 220px;
  }
  .visual-evidence-related {
    grid-template-columns: 1fr;
  }
  .hero-thesis div {
    grid-template-columns: 1fr;
    gap: 6px;
  }
  .map-visual {
    display: grid;
    gap: 10px;
    min-height: auto;
  }
  .map-node,
  .map-node.slovakia,
  .map-node.usa,
  .map-node.hongkong,
  .map-note {
    position: static;
    width: auto;
    max-width: none;
  }
  .deck-slide {
    padding: 144px 18px 96px;
  }
}
@media print {
  .deck-shell,
  .deck-viewport {
    height: auto;
    overflow: visible;
    background: #fff;
  }
  .deck-topbar,
  .deck-controls,
  .deck-progress,
  .speaker-notes,
  .source-drawer {
    display: none !important;
  }
  .deck-slide {
    min-height: auto;
    page-break-after: always;
    padding: 28px;
  }
  .slide-inner {
    min-height: auto;
    grid-template-columns: 1fr 1fr;
  }
  .slide-copy h1 {
    font-size: 34px;
  }
  .hero-visual,
  .question-visual,
  .counter-visual,
  .compare-visual,
  .workslop-visual,
  .fake-visual,
  .quiz-visual,
  .terminal-visual,
  .case-visual,
  .map-visual,
  .checklist-visual,
  .defense-visual,
  .rebuttal-visual,
  .conclusion-visual,
  .qa-visual,
  .citation-page-visual,
  .visual-evidence,
  .default-visual {
    box-shadow: none;
  }
  .citation-groups {
    max-height: none;
    overflow: visible;
  }
}`],
})
export class PageSlidesAiHarmsComponent implements OnInit, AfterViewInit, OnDestroy {
    public slides: Slide[] = [
        {
            eyebrow: '도입',
            title: '문제는 생성이 아니라 검증 책임이다',
            message: '생성형 AI의 핵심 위험은 산출물을 만든다는 사실이 아니라, 검증되지 않은 산출물이 신뢰의 형식으로 유통된다는 데 있다.',
            theme: 'ink',
            kind: 'hero',
            time: '0:40',
            claim: '오늘의 주장: AI 활용의 기준은 “잘 만들었는가”보다 “누가 확인했고 누가 책임지는가”여야 한다.',
            tags: ['학습', '업무 재작업', '허위정보', '데이터 오염', '할루시네이션', '보안'],
            citations: [1, 2, 3],
            evidence: ['aiIndex2026', 'nistGenAI'],
            notes: '첫 문장은 단호하게 말한다. 이 발표는 AI 반대론이 아니라 검증 책임론이라고 선을 긋고, 이후 모든 사례가 이 주장으로 돌아온다고 예고한다.'
        },
        {
            eyebrow: '문제 제기',
            title: '우리는 결과보다 검증 과정을 더 빨리 생략하고 있다',
            message: 'AI 결과물은 편리하지만, 편리함은 원문 확인과 책임 판단을 뒤로 미루게 만든다.',
            theme: 'indigo',
            kind: 'questions',
            time: '0:50',
            claim: '핵심 질문: AI가 답했는가가 아니라, 그 답을 누가 검증했는가.',
            bullets: ['AI가 만든 요약을 원문 없이 믿은 적이 있는가', '그럴듯한 출처를 실제로 눌러본 적이 있는가', 'AI 문서를 받은 뒤 오히려 다시 고친 적이 있는가'],
            citations: [2, 6, 10],
            evidence: ['unescoGuidance'],
            notes: '청중에게 세 질문을 던진다. 경험을 확인한 뒤, 개인의 부주의가 아니라 구조적 책임 공백의 문제라고 전환한다.'
        },
        {
            eyebrow: '발표 구조',
            title: '여섯 가지 폐해는 하나의 질문으로 모인다',
            message: '학습, 노동, 정보 신뢰, 데이터 생태계, 보안의 문제는 결국 검증 책임의 배분 문제로 연결된다.',
            theme: 'zinc',
            kind: 'figure',
            figure: 'harmsMap',
            time: '1:00',
            claim: '따로 보이는 피해들은 모두 “검증되지 않은 생성물의 이동”이라는 같은 구조를 가진다.',
            bullets: ['학습 과정의 생략', '업무 재작업 비용의 전가', '정보 신뢰와 절차의 공격', '데이터 오염과 보안 악용'],
            citations: [2, 3, 7, 9, 11, 12],
            evidence: ['nistGenAI', 'owaspLLMTop10'],
            notes: '도식을 보며 발표의 지도를 제시한다. 각 항목을 설명형으로 나열하지 말고, 모두 같은 논제로 수렴한다는 점을 먼저 말한다.'
        },
        {
            eyebrow: '현황',
            title: '생성은 쉬워졌고 검증은 어려워졌다',
            message: '생성 비용 하락, 쉬운 인터페이스, 조직 도입은 생성물의 양을 늘렸지만 검증 체계는 같은 속도로 커지지 않았다.',
            theme: 'slate',
            kind: 'counters',
            time: '1:00',
            claim: '위험의 출발점은 AI가 똑똑해졌다는 사실보다, 검증 속도가 생성 속도를 따라가지 못한다는 불균형이다.',
            bullets: ['짧은 프롬프트로 긴 문서와 이미지를 생성', '검색, 문서, 회의, 코딩 도구에 AI가 내장', '검증 체계보다 생성 속도가 빠르게 증가'],
            citations: [1, 2, 3],
            evidence: ['aiIndex2026'],
            notes: '숫자 자체를 길게 설명하지 않는다. “생성은 싸졌지만 검증은 여전히 비싸다”는 문장을 반복해 현황을 논지로 묶는다.'
        },
        {
            eyebrow: '학습',
            title: '학습의 문제는 AI 사용이 아니라 사고 과정의 생략이다',
            message: '학습은 정답을 얻는 일이 아니라, 근거를 찾고 자기 언어로 재구성하는 과정이다.',
            theme: 'indigo',
            kind: 'compare',
            time: '1:15',
            claim: '따라서 교육에서 물어야 할 것은 “AI를 썼는가”가 아니라 “학습자가 어떤 사고 과정을 거쳤는가”이다.',
            bullets: ['읽기와 요약을 건너뛰면 이해가 약해진다', 'AI 답변 제출은 표절보다 사고 생략 문제가 크다', 'AI 리터러시와 과정 중심 평가가 필요하다'],
            citations: [2, 4, 5],
            evidence: ['unescoGuidance'],
            notes: 'AI 사용 자체를 금지해야 한다는 식으로 말하지 않는다. 도구 사용과 사고 대체를 구분하고, 과정 중심 평가로 논지를 끌고 간다.'
        },
        {
            eyebrow: '업무',
            title: 'Workslop은 생산성이 아니라 검증 비용의 이동일 수 있다',
            message: '겉보기에는 완성된 AI 문서가 실제로는 동료에게 맥락 확인과 재작성 비용을 넘길 수 있다.',
            theme: 'emerald',
            kind: 'workslop',
            time: '1:15',
            claim: '생산성 평가는 생성 시간만 보아서는 안 되며, 수신자의 검증 시간까지 포함해야 한다.',
            bullets: ['겉보기에는 완성된 문서', '실제 맥락과 판단은 부족', '수신자가 다시 검토하고 수정'],
            citations: [6],
            evidence: ['workslopReport'],
            notes: '청중이 체감할 수 있는 업무 예시로 말한다. “내 시간이 줄었는가, 아니면 누군가의 시간이 늘었는가”라는 질문으로 논설적인 힘을 만든다.'
        },
        {
            eyebrow: '정보 신뢰',
            title: '허위정보는 사람보다 절차의 신뢰를 먼저 무너뜨린다',
            message: '딥페이크와 AI 허위정보는 더 싸고 빠르게, 더 그럴듯하게 유통되며 사회적 의사결정 절차를 흔든다.',
            theme: 'rose',
            kind: 'fake',
            time: '1:15',
            claim: '딥페이크의 위험은 “진짜처럼 보인다”가 아니라, 선거와 금융 같은 검증 절차를 통과하려 한다는 데 있다.',
            bullets: ['텍스트, 이미지, 음성, 영상이 모두 합성 가능', '선거와 금융 사기에서 피해가 커짐', '탐지만으로는 실제 유통 딥페이크를 따라가기 어렵다'],
            citations: [7, 8, 18, 19, 20],
            evidence: ['deepfakeEval', 'oecdFactsNotFakes'],
            notes: '시각적 충격보다 절차적 피해를 강조한다. 선거, 송금, 여론 형성처럼 신뢰가 전제된 절차가 공격받는다고 말한다.'
        },
        {
            eyebrow: '데이터',
            title: '검증되지 않은 데이터 순환은 미래 모델도 약하게 만든다',
            message: 'AI 생성물이 다시 학습 데이터가 되면 현재의 오류가 미래 모델의 품질과 다양성 문제로 돌아올 수 있다.',
            theme: 'amber',
            kind: 'figure',
            figure: 'dataCycle',
            time: '1:00',
            claim: '데이터 오염은 오늘의 콘텐츠 문제가 아니라 내일의 지식 인프라 문제다.',
            bullets: ['모델 출력이 다시 학습 데이터로 유입', '출처와 품질이 관리되지 않으면 순환 오염 발생', '장기적으로 다양성과 정확성 저하 가능'],
            citations: [3, 9],
            evidence: ['natureModelCollapse'],
            notes: '모델 붕괴를 공포스럽게 과장하지 않는다. 합성 데이터 자체보다, 출처와 품질이 확인되지 않은 순환이 위험하다고 차분하게 설명한다.'
        },
        {
            eyebrow: '할루시네이션',
            title: '출처 형식은 진실의 증거가 아니다',
            message: '틀린 답보다 위험한 것은 자신감 있고 문헌 형식까지 갖춘 틀린 답이다.',
            theme: 'sky',
            kind: 'quiz',
            time: '1:15',
            claim: 'AI의 출처 표기는 검증의 시작점일 뿐이며, 검증의 완료를 의미하지 않는다.',
            bullets: ['존재하지 않는 판례도 형식은 그럴듯할 수 있다', '법률, 의료, 행정, 금융에서는 검증 책임이 특히 크다', 'AI가 제시한 출처도 실제 존재 여부를 확인해야 한다'],
            citations: [10, 21, 22, 23],
            evidence: ['hallucinationSurvey'],
            notes: '퀴즈는 잠깐만 사용한다. 정답을 보여준 뒤, 형식과 진실을 구분해야 한다는 문장을 분명히 남긴다.'
        },
        {
            eyebrow: '보안',
            title: 'AI가 권한을 가지면 텍스트가 시스템 위험이 된다',
            message: 'AI가 도구와 연결되면 텍스트 오류가 실제 시스템 위험으로 확장된다.',
            theme: 'violet',
            kind: 'terminal',
            time: '1:15',
            claim: 'Jailbreak와 prompt injection의 공통점은 자연어 입력이 정책과 권한 경계를 흔든다는 데 있다.',
            bullets: ['안전정책 우회와 간접 prompt injection', '민감정보 노출과 임의 기능 호출', '에이전트 권한이 클수록 피해도 커짐'],
            citations: [11, 12, 13],
            evidence: ['owaspLLMTop10', 'jailbreakSurvey'],
            notes: '공격 절차를 설명하지 말고 방어 관점으로 말한다. 외부 문서와 사용자 입력은 신뢰할 수 없는 데이터이며, 권한을 줄이고 사람이 승인해야 한다고 정리한다.'
        },
        {
            eyebrow: '보안 세부',
            title: 'API key 유출과 채굴은 구분해야 한다',
            message: 'GPT API key 유출은 대량 추론과 과금 피해, cryptojacking은 주로 클라우드 권한 탈취 문제다.',
            theme: 'violet',
            kind: 'figure',
            figure: 'securityPaths',
            time: '1:05',
            claim: '같은 “키 유출”처럼 보여도 피해 경로가 다르므로 방어도 API 키 관리와 클라우드 권한 관리로 나누어야 한다.',
            bullets: ['API key 유출: 대량 추론과 과금 피해', '클라우드 credential 탈취: 리소스 남용과 cryptojacking', '키 관리와 최소권한이 핵심 방어선'],
            citations: [14, 15, 16, 17],
            evidence: ['openaiKeySafety', 'owaspLLMTop10'],
            notes: '사용자가 요청했던 API key 해킹과 채굴 내용을 정확히 구분한다. GPT API 키는 주로 추론 비용 남용이고, 채굴은 클라우드 리소스 권한 탈취와 연결된다고 말한다.'
        },
        {
            eyebrow: '세계 사례',
            title: '사례들은 달라도 질문은 하나다',
            message: '법률, 선거, 항공, 공공 행정, 금융 사기, 클라우드 보안의 사례는 모두 책임 공백이 피해로 이어졌다는 점에서 닮아 있다.',
            theme: 'zinc',
            kind: 'figure',
            figure: 'globalTimeline',
            time: '1:20',
            claim: '사례의 국적보다 중요한 것은 반복되는 구조다. 생성물은 빠르게 이동했고, 검증 책임은 뒤늦게 따라왔다.',
            bullets: ['법률 문서의 허위 판례', '항공사 챗봇의 잘못된 안내', '공공 챗봇의 부정확한 행정 조언', '선거·금융 절차를 노린 딥페이크'],
            citations: [8, 18, 19, 20, 21, 22, 23],
            evidence: ['deepfakeEval', 'fccDeepfakeRobocall'],
            notes: '여기서 발표 속도를 조금 늦춘다. 사례 목록을 읽는 것이 아니라, 각 사례에서 “누가 검증했어야 했나”를 묻는 방식으로 연결한다.'
        },
        {
            eyebrow: '사례 1',
            title: 'AI가 말해도 책임은 사람과 조직에 남는다',
            message: 'AI 챗봇이나 AI 도구가 말했더라도 최종 책임은 조직과 전문가에게 남는다.',
            theme: 'sky',
            kind: 'flipcases',
            time: '1:15',
            claim: '법률과 공공 행정 영역에서 AI는 책임 주체가 될 수 없으며, 책임은 AI를 배치한 사람과 조직으로 돌아간다.',
            bullets: ['Mata v. Avianca(2023): 존재하지 않는 판례 제출', 'Air Canada(2024): 챗봇의 잘못된 환불 안내 책임', 'NYC MyCity(2024): 잘못된 행정 조언 논란'],
            citations: [21, 22, 23],
            evidence: ['mataAvianca', 'canliiAirCanada'],
            notes: '세 사례의 결론은 하나다. “AI가 그렇게 말했다”는 면책 사유가 될 수 없다고 말하고, 책임 있는 배치와 검증의 필요로 이어간다.'
        },
        {
            eyebrow: '사례 2',
            title: '딥페이크는 사람보다 절차를 속인다',
            message: '목소리와 얼굴의 신뢰가 무너지면 선거 참여와 송금 승인 절차가 공격 대상이 된다.',
            theme: 'rose',
            kind: 'mapcases',
            time: '1:15',
            claim: '딥페이크 대응은 탐지 기술만으로 부족하며, 중요한 결정에는 별도 검증 절차가 필요하다.',
            bullets: ['슬로바키아(2023): 선거 직전 조작 음성', '미국 New Hampshire(2024): Biden 음성 로보콜', '홍콩(2024): 딥페이크 화상회의 송금 사기'],
            citations: [18, 19, 20],
            evidence: ['fccDeepfakeRobocall', 'hongKongDeepfakeGuardian'],
            notes: '탐지율 경쟁으로 빠지지 않는다. 중요한 송금, 선거 정보, 공식 발표에는 별도 채널 확인과 지연 승인 같은 절차 설계가 필요하다고 말한다.'
        },
        {
            eyebrow: '대응 1',
            title: '교육은 결과가 아니라 검증 과정을 평가해야 한다',
            message: '결과물보다 과정과 검증을 평가해야 한다.',
            theme: 'indigo',
            kind: 'checklist',
            time: '1:15',
            claim: '개인의 사용 윤리와 교육기관의 평가 설계가 함께 바뀌어야 학습 폐해를 줄일 수 있다.',
            bullets: ['AI 답변은 원문과 공식 자료로 교차검증', 'AI 사용 사실과 사용 범위 공개', '과정 중심 평가와 AI 리터러시 교육'],
            citations: [2, 4, 10, 14],
            evidence: ['unescoGuidance', 'openaiKeySafety'],
            notes: '대응책을 체크리스트처럼 빠르게 읽되, 개인 책임론으로만 끝내지 않는다. 평가 방식과 과제 설계가 함께 바뀌어야 한다고 강조한다.'
        },
        {
            eyebrow: '대응 2',
            title: '기업과 정부는 검증 책임을 시스템으로 설계해야 한다',
            message: '책임, 출처, 권한, 피해 구제를 제도와 시스템으로 설계해야 한다.',
            theme: 'emerald',
            kind: 'defense',
            time: '1:15',
            claim: '대규모 생성물의 위험은 개인의 주의만으로 감당할 수 없으므로, 조직의 책임 구조가 필요하다.',
            bullets: ['산출물 책임자와 human-in-the-loop', '생성물 표시와 provenance', 'API key와 클라우드 credential 최소권한', '정보 무결성과 피해 구제 기준'],
            citations: [3, 7, 11, 12, 14, 16],
            evidence: ['nistGenAI', 'owaspLLMTop10'],
            notes: '이 슬라이드는 정책적 결론의 핵심이다. 책임자, 출처, 권한, 피해 구제를 네 층으로 말하고, 검증 책임을 시스템으로 만들자고 정리한다.'
        },
        {
            eyebrow: '반론 검토',
            title: '그렇다면 AI를 금지해야 하는가',
            message: '폐해가 크다는 사실이 곧 전면 금지를 뜻하지는 않는다. 필요한 것은 무조건적 허용도, 무조건적 금지도 아닌 조건부 사용 원칙이다.',
            theme: 'amber',
            kind: 'rebuttal',
            time: '1:00',
            claim: '반론에 대한 답: AI는 사용할 수 있다. 다만 출처, 공개, 권한, 책임이 설계된 경우에만 신뢰할 수 있다.',
            bullets: ['금지는 활용 가능성을 닫고, 무조건 허용은 피해 비용을 숨긴다', '출처와 사용 범위를 공개해야 한다', '고위험 영역은 사람의 검토와 책임자를 남겨야 한다'],
            citations: [2, 3, 11, 12, 14],
            evidence: ['nistGenAI', 'unescoGuidance'],
            notes: '논설 발표에서 중요한 반론 처리다. AI 금지론과 낙관론을 모두 피하고, 조건부 사용이라는 제3의 결론을 제시한다.'
        },
        {
            eyebrow: '결론',
            title: 'AI 시대의 핵심 역량은 생성 능력이 아니라 검증 능력이다',
            message: 'AI는 보조 도구가 될 수 있지만, 판단·검증·책임까지 자동화해서는 안 된다.',
            theme: 'ink',
            kind: 'conclusion',
            time: '1:00',
            claim: '최종 결론: 생성형 AI를 둘러싼 신뢰 위기는 기술 문제가 아니라 검증 책임의 설계 문제다.',
            bullets: ['AI를 쓸 수 있다', '그러나 검증 없이 넘기면 안 된다', '누가 확인하고 책임지는지 설계해야 한다'],
            citations: [2, 3, 7, 9, 12],
            evidence: ['nistGenAI', 'natureModelCollapse'],
            notes: '최종 주장을 천천히 말한다. “생성 능력보다 검증 능력”이라는 문장을 발표의 마지막 핵심 문장으로 남긴다.'
        },
        {
            eyebrow: '질의응답',
            title: '토론은 찬반이 아니라 책임 설계로 가야 한다',
            message: '질의응답은 AI를 쓸 것인가 말 것인가보다, 어떤 조건에서 누가 검증하고 책임질 것인가로 모아야 한다.',
            theme: 'zinc',
            kind: 'qa',
            time: '0:50',
            claim: '질문의 방향: 기술 찬반이 아니라 신뢰를 유지하는 제도와 절차의 설계.',
            bullets: ['검증 책임은 개인, 조직, 플랫폼 중 어디에 두어야 하는가', 'AI 사용 공개는 윤리인가, 제도인가', '교육 평가는 결과보다 과정을 얼마나 보아야 하는가', '딥페이크 피해 구제는 사후 대응만으로 충분한가'],
            citations: [1, 2, 3, 7, 9, 11, 14, 18, 19, 22, 23],
            evidence: ['aiIndex2026', 'nistGenAI'],
            notes: '질문이 기술 찬반으로 흐르면 다시 책임 설계로 돌린다. 필요한 경우 참고문헌 페이지를 열어 근거를 바로 확인한다.'
        },
        {
            eyebrow: '부록',
            title: '인용 및 참고문헌',
            message: '본문의 [번호] 표기와 같은 순서로 논문, 보고서, 공식자료, 사례 출처를 정리했습니다.',
            theme: 'zinc',
            kind: 'citations',
            time: '부록',
            bullets: ['본문에서 사용한 번호 체계를 유지', '논문·보고서·공식자료·사례를 구분', '원문 링크와 근거 자료를 함께 확인 가능'],
            evidence: ['aiIndex2026', 'unescoGuidance'],
            notes: '발표 후 질의응답과 자료 공유 상황에서 참고문헌 페이지를 사용한다.'
        }
    ];

    public currentIndex: number = 0;
    public notesOpen: boolean = false;
    public sourcesOpen: boolean = false;
    public printMode: boolean = false;
    public exportingPptx: boolean = false;
    public workslopMode: 'generated' | 'repaired' = 'generated';
    public quizChoice: string = '';
    public figures: { [key: string]: SafeHtml } = {};
    public references: Reference[] = [];
    public captures: { [key: string]: EvidenceCapture } = { ...FALLBACK_CAPTURES };
    public selectedReference: number | null = null;
    public sourceMode: 'all' | 'paper' | 'report' | 'case' = 'all';
    private observer?: IntersectionObserver;

    constructor(@Inject( Service) public service: Service,@Inject( DomSanitizer)  private sanitizer: DomSanitizer) { }

    public async ngOnInit() {
        await this.service.init();
        await this.loadAssets();
    }

    public ngAfterViewInit() {
        window.setTimeout(() => this.setupObserver(), 250);
    }

    public ngOnDestroy() {
        if (this.observer) this.observer.disconnect();
    }

    public get currentSlide() {
        return this.slides[this.currentIndex];
    }

    public get progressWidth() {
        return `${((this.currentIndex + 1) / this.slides.length) * 100}%`;
    }

    public async loadAssets() {
        const { code, data }: any = await wiz.call('assets');
        if (code !== 200) {
            await this.service.render();
            return;
        }
        this.references = data?.references || [];
        this.captures = { ...FALLBACK_CAPTURES, ...(data?.captures || {}) };
        const rawFigures = data?.figures || {};
        Object.keys(rawFigures).forEach((key) => {
            this.figures[key] = this.sanitizer.bypassSecurityTrustHtml(rawFigures[key] || '');
        });
        await this.service.render();
    }

    public setupObserver() {
        const nodes = Array.from(document.querySelectorAll('.deck-slide'));
        this.observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                const index = Number((entry.target as HTMLElement).dataset.index || 0);
                this.currentIndex = index;
                this.service.render();
            });
        }, { threshold: 0.62 });
        nodes.forEach((node) => this.observer?.observe(node));
    }

    public go(index: number) {
        const next = Math.max(0, Math.min(this.slides.length - 1, index));
        this.currentIndex = next;
        document.getElementById(`slide-${next}`)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    public next() {
        this.go(this.currentIndex + 1);
    }

    public prev() {
        this.go(this.currentIndex - 1);
    }

    public toggleSources(ref?: number) {
        if (ref) {
            this.showSource(ref);
            return;
        }
        this.sourcesOpen = !this.sourcesOpen;
    }

    public showSource(ref: number) {
        this.selectedReference = ref;
        this.sourcesOpen = true;
    }

    public refById(id: number) {
        return this.references.find((item) => item.id === id);
    }

    public refText(id: number) {
        return this.refById(id)?.text || `참고문헌 ${id}`;
    }

    public selectedReferenceItem() {
        if (!this.selectedReference) return undefined;
        return this.refById(this.selectedReference);
    }

    public slideReferences(slide: Slide = this.currentSlide) {
        return (slide.citations || [])
            .map((id) => this.refById(id))
            .filter((item) => !!item) as Reference[];
    }

    public evidenceReferences(slide: Slide = this.currentSlide) {
        return this.slideReferences(slide).filter((item) => ['paper', 'report', 'standard'].includes(item.kind));
    }

    public evidenceItems(slide: Slide = this.currentSlide) {
        return (slide.evidence || [])
            .map((key) => this.captures[key])
            .filter((item) => !!item) as EvidenceCapture[];
    }

    public primaryEvidence(slide: Slide = this.currentSlide) {
        return this.evidenceItems(slide)[0];
    }

    public secondaryEvidenceItems(slide: Slide = this.currentSlide) {
        return this.evidenceItems(slide).slice(1, 3);
    }

    public citationGroups() {
        return [
            {
                title: '논문',
                note: '학술지 및 arXiv 학술자료',
                refs: this.references.filter((item) => item.kind === 'paper')
            },
            {
                title: '보고서·기관자료',
                note: '국제기구, 표준, 공식 문서',
                refs: this.references.filter((item) => ['report', 'standard', 'official'].includes(item.kind))
            },
            {
                title: '사례·기사',
                note: '법률, 선거, 금융 사기 사례',
                refs: this.references.filter((item) => ['case', 'news'].includes(item.kind))
            }
        ];
    }

    public bibliographyReferences() {
        return [...this.references].sort((a, b) => a.id - b.id);
    }

    public filteredReferences() {
        if (this.sourceMode === 'paper') return this.references.filter((item) => item.kind === 'paper');
        if (this.sourceMode === 'report') return this.references.filter((item) => ['report', 'standard', 'official'].includes(item.kind));
        if (this.sourceMode === 'case') return this.references.filter((item) => ['case', 'news'].includes(item.kind));
        return this.references;
    }

    public figure(key?: string) {
        if (!key) return '';
        return this.figures[key] || '';
    }

    public chooseQuiz(choice: string) {
        this.quizChoice = choice;
    }

    public setWorkslopMode(mode: 'generated' | 'repaired') {
        this.workslopMode = mode;
    }

    public async toggleFullscreen() {
        const doc: any = document;
        if (!document.fullscreenElement) {
            await document.documentElement.requestFullscreen?.();
            return;
        }
        await doc.exitFullscreen?.();
    }

    public async downloadPptx() {
        if (this.exportingPptx) return;
        this.exportingPptx = true;
        await this.service.render();
        try {
            const { code, data }: any = await wiz.call('export_pptx');
            if (code !== 200 || !data?.data) return;

            const binary = atob(data.data);
            const bytes = new Uint8Array(binary.length);
            for (let i = 0; i < binary.length; i++) {
                bytes[i] = binary.charCodeAt(i);
            }
            const blob = new Blob([bytes], { type: data.mime || 'application/vnd.openxmlformats-officedocument.presentationml.presentation' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = data.filename || 'ai-harms-presentation.pptx';
            document.body.appendChild(link);
            link.click();
            link.remove();
            URL.revokeObjectURL(url);
        } finally {
            this.exportingPptx = false;
            await this.service.render();
        }
    }

    @HostListener('window:keydown', ['$event'])
    public onKeydown(event: KeyboardEvent) {
        const tag = (event.target as HTMLElement)?.tagName?.toLowerCase();
        if (tag === 'input' || tag === 'textarea') return;
        const key = event.key.toLowerCase();
        if (['arrowright', 'pagedown', ' '].includes(key)) {
            event.preventDefault();
            this.next();
        }
        if (['arrowleft', 'pageup'].includes(key)) {
            event.preventDefault();
            this.prev();
        }
        if (key === 'home') this.go(0);
        if (key === 'end') this.go(this.slides.length - 1);
        if (key === 'n') this.notesOpen = !this.notesOpen;
        if (key === 's') this.sourcesOpen = !this.sourcesOpen;
        if (key === 'p') this.printMode = !this.printMode;
        if (key === 'f') this.toggleFullscreen();
        this.service.render();
    }
}

export default PageSlidesAiHarmsComponent;